import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconPinOffLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 5h-4v2.175L7.567 4.742a.711.711 0 0 1-.163-.236.703.703 0 0 1-.048-.262c0-.19.064-.36.191-.514a.65.65 0 0 1 .528-.23h7.675a.72.72 0 0 1 .534.217.73.73 0 0 1 .216.536c0 .2-.087.347-.262.44A3.766 3.766 0 0 0 15.75 5h-.25v6c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216.725.725 0 0 1-.534-.216A.726.726 0 0 1 14 11V5Zm-2.75 16v-5.5H8.179c-.367 0-.66-.128-.881-.385a1.284 1.284 0 0 1-.33-.857c0-.158.03-.314.094-.469.063-.155.164-.302.304-.443L8.5 12.211V10.64L2.658 4.765a.743.743 0 0 1-.22-.514.7.7 0 0 1 .222-.541.714.714 0 0 1 .525-.216c.206 0 .382.073.527.218l16.177 16.177a.713.713 0 0 1 .22.53.787.787 0 0 1-.762.764.698.698 0 0 1-.528-.226L13.362 15.5h-.612V21c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534Zm-2.4-7h3.03l-1.85-1.83-.03.68L8.85 14Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconPinOffLine;
